import styled from 'styled-components';

export const DropdownWrap = styled.div`
  position: relative;
  z-index: ${p => p.zIndex || 'auto'};
`;
